import * as React from "react";

// Types
import Icon from "../../types/Icon.interface";

const IconClose: React.FC<Icon> = (props: Icon) => {
  const { color = "#002D5A", size = 18, className, style, onClick } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      style={style}
      onClick={onClick}
    >
      <g fill={color}>
        <path d="M16 3.272L3.272 16 2 14.728 14.728 2z" />
        <path d="M14.728 16L2 3.272 3.272 2 16 14.728z" />
      </g>
    </svg>
  );
};

export default IconClose;
